import { Link } from "react-router-dom";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { RiUserSettingsLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";

export default function Settings() {
  const { t } = useTranslation();

  return (
    <ContentLayout
      header={
        <>
          <h1>{t("settings")}</h1>
          <MyBreadcrumb />
          <div className="settings-items">
            {/* <Link to="account" className="settings-item">
              <CgProfile size={24} />
              <p>Your Account</p>
            </Link> */}
            <Link to="roles" className="settings-item">
              <RiUserSettingsLine size={24} />
              <p>{t("account_roles")}</p>
            </Link>
            <Link to="membership" className="settings-item">
              <MdOutlineBusinessCenter size={24} />
              <p>Membership</p>
            </Link>
            {/* <Link to="account" className="settings-item">
              <MdOutlineHeadsetMic size={24} />
              <p>Support</p>
            </Link> */}
          </div>
        </>
      }
    ></ContentLayout>
  );
}
